import {createSelector} from 'reselect'
import {isLicenseExpired, isLicenseViolated, loggedInUserCanManageLicenses, wasOtherProductEverIntegrated} from '../../activeLicenseInfo/selectors'
import {canManageAccountsAndPermissions, canManageSystemSettings} from '../../loggedInUser/selectors'
import {isOlVersion, PRODUCT_SWITCHER_URL} from '../../constants'
import {isQBIEnabled} from '../../features/selectors'

const getAddonsState = state => state.addons

export const isAddonsMenuShown = state => getAddonsState(state).isShown

export const isShowApIntegrationAction = createSelector(
    isLicenseExpired,
    isLicenseViolated,
    loggedInUserCanManageLicenses,
    canManageSystemSettings,
    canManageAccountsAndPermissions,
    wasOtherProductEverIntegrated,
    (
        licenseExpired,
        licenseViolated,
        canManageLicense,
        manageSystemSettings,
        manageAccountsAndPermissions,
        wasOtherProductEverIntegrated,
    ) => {
        return !isOlVersion
               || !!PRODUCT_SWITCHER_URL
               || (!wasOtherProductEverIntegrated && (canManageLicense || manageAccountsAndPermissions) && !licenseExpired && !licenseViolated)
               || (wasOtherProductEverIntegrated && canManageLicense)
    }
)

export const isQbiAvailable = createSelector(
    isLicenseViolated,
    isLicenseExpired,
    isQBIEnabled,
    (isLicenseViolated, isLicenseExpired, isQBIEnabled) => !isLicenseViolated && !isLicenseExpired && isQBIEnabled
)


// WEBPACK FOOTER //
// ./web/js/support/addons/selectors.js